import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, bool_type, class_type, int32_type, option_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class CreateContractDTO extends Record {
    constructor(ClientCrossRef, ContractNumber, ContractTypeCode, CreatedBy, CreatedTime, EndUser, EndUserCategory, EndUserOrganizationnr, ObjectNumber, ProductNumber, SpecifiedInvoice, UpdatedTime, StartDate, NoNextInvoice) {
        super();
        this.ClientCrossRef = ClientCrossRef;
        this.ContractNumber = ContractNumber;
        this.ContractTypeCode = ContractTypeCode;
        this.CreatedBy = CreatedBy;
        this.CreatedTime = CreatedTime;
        this.EndUser = EndUser;
        this.EndUserCategory = EndUserCategory;
        this.EndUserOrganizationnr = EndUserOrganizationnr;
        this.ObjectNumber = ObjectNumber;
        this.ProductNumber = ProductNumber;
        this.SpecifiedInvoice = SpecifiedInvoice;
        this.UpdatedTime = UpdatedTime;
        this.StartDate = StartDate;
        this.NoNextInvoice = NoNextInvoice;
    }
}

export function CreateContractDTO$reflection() {
    return record_type("Containers.CreateSubscription.Model.CreateContractDTO", [], CreateContractDTO, () => [["ClientCrossRef", option_type(string_type)], ["ContractNumber", option_type(int32_type)], ["ContractTypeCode", string_type], ["CreatedBy", option_type(string_type)], ["CreatedTime", option_type(class_type("System.DateTime"))], ["EndUser", option_type(string_type)], ["EndUserCategory", option_type(string_type)], ["EndUserOrganizationnr", option_type(string_type)], ["ObjectNumber", option_type(int32_type)], ["ProductNumber", option_type(int32_type)], ["SpecifiedInvoice", option_type(bool_type)], ["UpdatedTime", option_type(class_type("System.DateTime"))], ["StartDate", option_type(string_type)], ["NoNextInvoice", option_type(bool_type)]]);
}

